import Axios from 'axios'
import Storage from 'util/store/Storage'
import Swal from 'sweetalert2'
import server from 'util/Server'
import { sessionCaducada } from 'util/funciones'

const { empresasHijos, negocio, usuario } = Storage.getState()
const headers = { Authorization: server.obtenerToken() }

export const postRequestImportador = (data: any, ruta: string): Promise<any> => {
    const mostrarErrores = (productos: any[]) => {
        return productos?.map((pro: any) => `<p><b>${pro.producto}</b><br>${pro.razon}`)
    }
    return new Promise((resolve, reject) => {
        Axios.post(`${server.host}${server.puertoCentury}/api/importadores/${ruta}`, data, { headers: headers })
            .then(res => {
                if (res.status === server.responseSucces) {
                    Swal.fire({
                        title: 'OK',
                        text: 'DATOS IMPORTADOS CORRECTAMENTE',
                        icon: 'success'
                    })
                    resolve(res.data)
                } else if (res.status === server.responsePartialContent) {
                    Swal.fire({
                        title: 'OK',
                        html: `  <b> UNO O VARIOS DATOS NO SE IMPORTARON CORRECTAMENTE </b> <br>
                      <div class='overflow-auto' style = "max-height: 200px; margin-top: 10px;"  >${mostrarErrores(
                            res.data.productos
                        )}</p><br></div>`,
                        icon: 'warning'
                    })

                    resolve(res.data)
                } else if (res.status === server.responseSesionCaducada) {
                    resolve(undefined)
                    sessionCaducada()
                } else {
                    Swal.fire({
                        title: 'ERROR',
                        text: res.data.mensaje.toUpperCase() || 'NO SE PUDO IMPORTAR LOS DATOS',
                        icon: 'error'
                    })
                    resolve(undefined)
                }
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.productos) {
                    const errors = error.response.data;
                    Swal.fire({
                        title: 'ADVERTENCIA',
                        html: `  <b> UNO O VARIOS DATOS NO SE IMPORTARON CORRECTAMENTE </b> <br>
                    <div class='overflow-auto' style = "max-height: 200px; margin-top: 10px;"  >${mostrarErrores(
                            errors.productos || []
                        )}</p><br></div>`,
                        icon: 'warning'
                    })
                } else {
                    Swal.fire({
                        title: 'ERROR',
                        text: error.response.data.mensaje || 'NO SE PUDO IMPORTAR LOS DATOS',
                        icon: 'error'
                    })
                }
                console.error(error)
                reject(undefined)
            })
    })
}

const empleadosDuplicados = (res: any) => {
    if (!res.data.data) return ''
    if (res.data.data.length > 0) {
        return (
            `<b style="margin: 0; padding: 0">EMPLEADOS DUPLICADOS NO REGISTRADOS:</b>` +
            res.data.data
                .map(
                    (data: any) =>
                        `<p style="margin: 0; padding: 0; font-size: 16px; text-align: left">${'- ' + data.usuario}</p>`
                )
                .join(' ')
        )
    }
    return 'No existen empleados duplicados'
}

//IMPORTADOR DE CLIENTES
export const postRequestImportadorClientes = (data: any, ruta: string): Promise<any> => {
    return Axios.post(`${server.host}${server.puertoCentury}/api/importadores/${ruta}`, data, { headers: headers })
}

//IMPORTADOR DE EMPLEADOS
export const ImportadorEmpleados = (data: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        Axios.post(`${server.host}${server.puertoCentury}/api/importadores/empleados`, data, { headers: headers })
            .then(res => {
                if (res.status === server.responseSucces) {
                    Swal.fire({
                        title: 'OK',
                        html: `<h2> ${res.data.mensaje} </h2><br>
            <div style="max-height: 300px; overflow: auto;">
              ${empleadosDuplicados(res)}
            </div>`,
                        icon: 'success'
                    })
                    resolve(res.data)
                } else if (res.status === server.responseOK) {
                    Swal.fire({
                        title: 'HA OCURRIDO UN ERROR!',
                        html: `<h2> ${res.data.mensaje} </h2><br>
            <div style="max-height: 300px; overflow: auto;">
              ${res.data.data !== null && res.data.data.length > 0
                                ? `<b style="margin: 0; padding: 0">EMPLEADOS DUPLICADOS NO REGISTRADOS:</b>` +
                                res.data.data
                                    .map(
                                        (data: any) =>
                                            `<p style="margin: 0; padding: 0; font-size: 16px; text-align: left">${'- ' +
                                            data.usuario}</p>`
                                    )
                                    .join(' ')
                                : 'No existen empleados duplicados'
                            }
            </div>`,
                        icon: 'error'
                    })
                    resolve(res.data)
                } else if (res.status === server.responseSesionCaducada) {
                    resolve(undefined)
                    sessionCaducada()
                } else {
                    Swal.fire({
                        title: 'ERROR',
                        text: res.data.mensaje.toUpperCase(),
                        icon: 'error'
                    })
                    resolve(undefined)
                }
            })
            .catch(error => {
                Swal.fire({
                    title: 'ERROR',
                    text: error.response.data.mensaje,
                    icon: 'error'
                })
                reject(error)
            })
    })
}

export const getEmpresas = (empresas?: string): Promise<any[]> => {
    return new Promise((resolve, reject) => {
        Axios.get(`${server.host}${server.puertoCentury}/api/empresa/select/empresa/5/${empresasHijos.length > 0 ? empresasHijos : empresas}`, {
            headers: headers
        })
            .then(res => {
                if (res.status === server.responseOK) {
                    resolve(res.data.data)
                } else if (res.status === server.responseSesionCaducada) {
                    resolve([])
                    sessionCaducada()
                }
            })
            .catch(err => {
                console.error(err)
                reject([])
            })
    })
}
export const getEmpresasByPerfil = (): Promise<any[]> => {
    const { negocio, usuario } = Storage.getState()
    const headers = { Authorization: server.obtenerToken() }

    return new Promise((resolve, reject) => {
        Axios.get(`${server.host}${server.puertoCentury}/api/empresa/select/empresas/${usuario.perfiles[0].id}/${negocio}`, {
            headers: headers
        })
            .then(res => {
                if (res.status === server.responseOK) {
                    resolve(res.data.data)
                } else if (res.status === server.responseSesionCaducada) {
                    resolve([])
                    sessionCaducada()
                }
            })
            .catch(err => {
                console.error(err)
                reject([])
            })
    })
}

export const getPriceByEdsAndFamily = async (empresa_id: number, id_familia: number) => {
    return Axios.get(`${server.host}${server.puertoCentury}/api/producto/precio/familiaProducto/${empresa_id}/${id_familia}`, {
        headers: headers
    })
}

export const getProveedores = (): Promise<any[]> => {


    return new Promise((resolve, reject) => {
        Axios.get(`${server.host}${server.puertoCentury}/api/proveedor/empresa/select/${negocio},${empresasHijos}`, {
            headers: headers
        })
            .then(res => {
                if (res.status === server.responseOK) {
                    resolve(res.data)
                } else if (res.status === server.responseSesionCaducada) {
                    resolve([])
                    sessionCaducada()
                }
            })
            .catch(err => {
                console.error(err)
                reject([])
            })
    })
}
